import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { FaLightbulb } from 'react-icons/fa';
import styled from 'styled-components';

export const PasswordPolicy = () => {
  const { t } = useTranslation();
  return (
    <Styled>
      <FaLightbulb />
      <Trans i18nKey="ui.password.hint">
        <a
          href={t('ui.password.zendeskSupportUrlForPassword')}
          rel="noopener noreferrer"
          target="_blank"
        ></a>
      </Trans>
    </Styled>
  );
};

const Styled = styled.div`
  margin: 0.75em 0 4em;
  font-size: 0.9em;

  display: flex;
  align-items: center;
  gap: 4px;
`;
